module.exports = __webpack_public_path__ + "img/Group_26848.2efacf92.png";